export default "__VITE_ASSET__19305936__"